const fonts = {
    primary: "'Roboto', sans-serif",
 
}

export default fonts